import React, { Component } from 'react';
import { Col } from 'reactstrap';

import classnames from 'classnames';

class Content extends Component {
  render() {
    var classes = this.props.className;
    var cols = 12;
    if(!this.props.fullWidth) {
      cols = 8;
    }

    return (
      <Col xs={12} md={cols} className={classnames('bg-light h-100 content ' + classes)}>
        {this.props.children}
      </Col>
    );
  }
}

export default Content;
